import { render, staticRenderFns } from "./deleteIp.vue?vue&type=template&id=f88ea268&lang=pug&"
import script from "./deleteIp.vue?vue&type=script&lang=js&"
export * from "./deleteIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports